import * as React from 'react';
import s from './collection-header.scss';
import { Box, Heading } from '@wix/design-system';
import type { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { composer } from '../../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { BackButton } from '../../back-button';
import type { GetWebSolutionsByTagsResponse } from '@wix/ambassador-marketplace/types';
import type { MarketplaceStore } from '../../../component-decorators/with-marketplace-store';

export interface ICollectionHeaderProps
  extends Partial<InjectedExperimentsProps>,
    Partial<WithTranslationProps> {
  marketplaceStore?: MarketplaceStore;
  name: string;
  teaser: string;
}

export const dtoToCollectionHeaderProps = (
  res: GetWebSolutionsByTagsResponse,
): ICollectionHeaderProps => {
  const name = res?.tagsAndSubCategories[0]?.tag?.name;
  const teaser =
    res?.tagsAndSubCategories[0]?.tag?.data?.collectionDate?.teaser;
  return {
    name,
    teaser,
  };
};

export const CollectionHeader = composer()
  .withExperiments()
  .withMarketplaceStore()
  .withTranslation()
  .compose(({ name, teaser, marketplaceStore }: ICollectionHeaderProps) => {
    const shouldShowBackButton =
      marketplaceStore?.prevRoute &&
      marketplaceStore.prevRoute.currentUrl !==
        marketplaceStore.route.currentUrl &&
      marketplaceStore?.route?.referral !== 'menu_navigation' &&
      marketplaceStore?.route?.referral !== 'back_button';
    return (
      <Box
        marginBottom="6px"
        direction="vertical"
        dataHook="collection-header"
        marginTop="24px"
      >
        {shouldShowBackButton && <BackButton skinColor="dark" />}
        <Heading
          appearance="H1"
          light={false}
          data-hook="collection-header-text"
          className={s.collectionTitle}
        >
          <span
            className={s.collectionName}
            data-testid="collection-header-name"
            data-hook="collection-header-name"
          >
            {name + ' '}
          </span>
          <span
            data-testid="collection-header-teaser"
            className={s.collectionTeaser}
          >
            {teaser}
          </span>
        </Heading>
      </Box>
    );
  });
